/**
 * Copyright 2023-2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import {
  EventDetailResourceFragment,
  EventDetailResourceGroupFragment,
  IncomingEventStatus,
} from "~/generated/graphql";
import { ResourceList } from "~/components/resourceGroup/ResourceList";

type Props = {
  resourceGroups: EventDetailResourceGroupFragment[];
  resources: EventDetailResourceFragment[];
  status?: IncomingEventStatus;
};

export function IncomingEventResourcesSection({
  resourceGroups,
  resources,
  status,
}: Props) {
  return (
    <ResourceList
      resourceGroups={resourceGroups}
      resources={resources}
      status={status}
    />
  );
}
